// @context TGW-2195 公開に必要なイベント名の字数。基本ページの入力欄・公開時の検証・エラー解消の判定で
//   別々に数字を書いていたため、解消条件だけ100字のまま残り、61〜100字でエラーがすぐ消えていた（PR #2536 Copilot 指摘）。
export const TITLE_MIN = 15;
export const TITLE_MAX = 60;

export const isPublishableTitle = (title) =>
  !!title && title.length >= TITLE_MIN && title.length <= TITLE_MAX;

export const titleLengthError = `タイトルは${TITLE_MIN}文字以上${TITLE_MAX}文字以内で入力してください。`;
